const swagger = {
    invalid_zod_type: 'Invalid Zod type. Please check route guard config.',
    not_supported_zod_type_for_params: 'Not supported Zod type for the parameters. Please check route guard config.',
};
export default swagger;
